import React, { useEffect, useState } from "react";
import Seo from "./Seo";
import { baseURL } from "./domainValidator";
import swal from 'sweetalert';
import Select from "react-select";

const email_domains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "hotmail.co.uk",
    "hotmail.fr",
    "msn.com",
    "yahoo.fr",
    "wanadoo.fr",
    "orange.fr",
    "comcast.net",
    "yahoo.co.uk",
    "yahoo.com.br",
    "yahoo.co.in",
    "live.com",
    "rediffmail.com",
    "free.fr",
    "gmx.de",
    "web.de",
    "yandex.ru",
    "ymail.com",
    "libero.it",
    "outlook.com",
    "uol.com.br",
    "bol.com.br",
    "mail.ru",
    "cox.net",
    "hotmail.it",
    "sbcglobal.net",
    "sfr.fr",
    "live.fr",
    "verizon.net",
    "live.co.uk",
    "googlemail.com",
    "yahoo.es",
    "ig.com.br",
    "live.nl",
    "bigpond.com",
    "terra.com.br",
    "yahoo.it",
    "neuf.fr",
    "yahoo.de",
    "alice.it",
    "rocketmail.com",
    "att.net",
    "laposte.net",
    "facebook.com",
    "bellsouth.net",
    "yahoo.in",
    "hotmail.es",
    "charter.net",
    "yahoo.ca",
    "yahoo.com.au",
    "rambler.ru",
    "hotmail.de",
    "tiscali.it",
    "shaw.ca",
    "yahoo.co.jp",
    "sky.com",
    "earthlink.net",
    "optonline.net",
    "freenet.de",
    "t-online.de",
    "aliceadsl.fr",
    "virgilio.it",
    "home.nl",
    "qq.com",
    "telenet.be",
    "me.com",
    "yahoo.com.ar",
    "tiscali.co.uk",
    "yahoo.com.mx",
    "voila.fr",
    "gmx.net",
    "mail.com",
    "planet.nl",
    "tin.it",
    "live.it",
    "ntlworld.com",
    "arcor.de",
    "yahoo.co.id",
    "frontiernet.net",
    "hetnet.nl",
    "live.com.au",
    "yahoo.com.sg",
    "zonnet.nl",
    "club-internet.fr",
    "juno.com",
    "optusnet.com.au",
    "blueyonder.co.uk",
    "bluewin.ch",
    "skynet.be",
    "sympatico.ca",
    "windstream.net",
    "mac.com",
    "centurytel.net",
    "chello.nl",
    "live.ca",
    "aim.com",
    "bigpond.net.au"
];
const INITIAL_FORM = {
    name: "",
    email: "",
    organization: "",
    deviceCount: "",
    nms: [],
    otherNms: "",
    compliancePlatform: "",
    compliancePlatformName: "",
    hasChallenges: false,
    priority1: "",
    priority2: "",
    priority3: "",
    otherChallenge1: "",
    otherChallenge2: "",
    otherChallenge3: "",
    interest: "",
    consent: true,
};

const INITIAL_ERRORS = {
    name: "",
    email: "",
    deviceCount: "",
    nms: "",
    compliancePlatform: "",
    compliancePlatformName: "",
    hasChallenges: "",
    priority1: "",
    priority2: "",
    priority3: "",
    otherChallenge1: "",
    otherChallenge2: "",
    otherChallenge3: "",
    interest: "",
    consent: "",
};

const ErrorMsg = ({ message }) => {
    if (!message) return null;
    return (
        <div className="text-danger fw-bold mt-1" style={{ fontSize: "0.8rem" }}>
            {message}
        </div>
    );
}

const SectionHeading = ({ children }) => {
    return <h4 className="mt-4 mb-3 border-bottom pb-2">{children}</h4>;
}

export default function QueryForm() {
    const [formData, setFormData] = useState(INITIAL_FORM);
    const [errors, setErrors] = useState(INITIAL_ERRORS);
    const [formConfig, setFormConfig] = useState([]);


    const fetchData = async () => {
        try {
            const response = await fetch(`${baseURL}/form-config`);
            const data = await response.json();

            if (data?.success) {
                setFormConfig(data.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const clearError = (field) =>
        setErrors((prev) => ({ ...prev, [field]: "" }));

    const setError = (field, msg) =>
        setErrors((prev) => ({ ...prev, [field]: msg }));

    const handleEmailChange = (e) => {
        setFormData((prev) => ({ ...prev, email: e.target.value }));
        clearError("email");
    };

    const handleTextField = (field) => (e) => {
        setFormData((prev) => ({ ...prev, [field]: e.target.value }));
        clearError(field);
    };

    const handleRadio = (field) => (e) => {
        setFormData((prev) => ({ ...prev, [field]: e.target.value }));
        clearError(field);
    };
    const handleNmsCheckbox = (e) => {
        const { value, checked } = e.target;

        setFormData((prev) => ({
            ...prev,
            nms: checked
                ? [...prev.nms, value]
                : prev.nms.filter((item) => item !== value),
        }));
    };

    const handleComplianceChange = (e) => {
        const value = e.target.value;

        setFormData((prev) => ({
            ...prev,
            compliancePlatform: value,
        }));
    };

    const challengeField = formConfig?.find(
        (field) => field.fieldKey === "complianceChallenges"
    );

    const challengeOptions =
        challengeField?.options?.filter(
            (item) => item.value !== "other"
        ) || [];

    const handlePriority1 = (e) => {
        const value = e.target.value;

        setFormData((prev) => ({
            ...prev,
            priority1: value,
            priority2: "",
            priority3: "",

            ...(value !== "other1" && {
                otherChallenge1: "",
            }),

            otherChallenge2: "",
            otherChallenge3: "",
        }));
    };

    const handlePriority2 = (e) => {
        const value = e.target.value;

        setFormData((prev) => ({
            ...prev,
            priority2: value,
            priority3: "",

            ...(value !== "other2" && {
                otherChallenge2: "",
            }),

            otherChallenge3: "",
        }));
    };

    const handlePriority3 = (e) => {
        const value = e.target.value;

        setFormData((prev) => ({
            ...prev,
            priority3: value,

            ...(value !== "other3" && {
                otherChallenge3: "",
            }),
        }));
    };

    const handleConsent = (e) => {
        setFormData((prev) => ({ ...prev, consent: e.target.checked }));
        clearError("consent");
    };


    const showOtherChallenge =
        formData.priority1 === "other" ||
        formData.priority2 === "other" ||
        formData.priority3 === "other"

    const validate = () => {
        const newErrors = { ...INITIAL_ERRORS };
        let valid = true;
        const blockedDomains = new Set(email_domains); // your array from API/config
        const email = formData.email.trim().toLowerCase();
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

        if (!email || !emailRegex.test(email)) {
            newErrors.email = "Please enter a valid email address.";
            valid = false;
        } else {
            const domain = email.split("@")[1];

            if (blockedDomains.has(domain)) {
                newErrors.email =
                    "Please enter your official business email address.";
                valid = false;
            }
        }
        if (!formData.name) {
            newErrors.name = "Please enter your name.";
            valid = false;
        }

        if (!formData.deviceCount) {
            newErrors.deviceCount = "Please select the number of devices you manage.";
            valid = false;
        }

        if (formData.nms.length === 0 && !formData.otherNms.trim()) {
            newErrors.nms = "Please select at least one NMS or enter one in the field above.";
              document.querySelector(".css-13cymwt-control").classList.add("border-danger");
              document.querySelector(".css-13cymwt-control").classList.add("is-invalid");
              document.querySelector(".css-13cymwt-control").scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
              document.querySelector(".css-13cymwt-control").focus();
            valid = false;
        }

        if (!formData.compliancePlatform) {
            newErrors.compliancePlatform = "Please indicate whether you use a compliance platform.";
            valid = false;
        }

        if (
            formData.nms.includes("other") &&
            !formData.otherNms.trim()
        ) {
            newErrors.nms = "Please specify the Other NMS.";
            valid = false;
        }

        if (
            formData.compliancePlatform === "yes" &&
            !formData.compliancePlatformName.trim()
        ) {
            newErrors.compliancePlatformName = "Please enter your compliance platform name.";
            valid = false;
        }
       
       if (!formData.hasChallenges) {

    if (!formData.priority1) {
        newErrors.priority1 =
            "Please select your top priority.";
        valid = false;
    }

    if (
        formData.priority1 === "other1" &&
        !formData.otherChallenge1?.trim()
    ) {
        newErrors.otherChallenge1 =
            "Please specify Other Challenge 1.";
        valid = false;
    }

    if (!formData.priority2) {
        newErrors.priority2 =
            "Please select your second priority.";
        valid = false;
    }

    if (
        formData.priority2 === "other2" &&
        !formData.otherChallenge2?.trim()
    ) {
        newErrors.otherChallenge2 =
            "Please specify Other Challenge 2.";
        valid = false;
    }

    if (!formData.priority3) {
        newErrors.priority3 =
            "Please select your third priority.";
        valid = false;
    }

    if (
        formData.priority3 === "other3" &&
        !formData.otherChallenge3?.trim()
    ) {
        newErrors.otherChallenge3 =
            "Please specify Other Challenge 3.";
        valid = false;
    }
}
        // if (!formData.hasChallenges) {
        //     newErrors.hasChallenges =
        //         "Please select an option.";
        //     valid = false;
        // }
        if (!formData.interest) {
            newErrors.interest = "Please select a follow-up preference.";
            valid = false;
        }

        // if (!formData.consent) {
        //     newErrors.consent = "Please accept the consent to proceed.";
        //     valid = false;
        // }

        setErrors(newErrors);
        return valid;
    };

    const getField = (fieldKey) =>
        formConfig.find((item) => item.fieldKey === fieldKey);



    const scrollToFirstError = () => {
    setTimeout(() => {
        const firstError = document.querySelector(".is-invalid");

      

        if (firstError) {
            firstError.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });

            firstError.focus();
        }
    }, 100);
};

    // --- Submit ---
    const handleSubmit = async (e) => {
        e.preventDefault();

 if (!validate()) {
    scrollToFirstError();
    return;
}

  const payload = {
    name: formData.name,

    businessEmail: formData.email,

    organizationName: formData.organization,

    deviceCount: formData.deviceCount,

    nmsTools: formData.nms,

    nmsOther: formData.otherNms,

    usesCompliancePlatform: formData.compliancePlatform,

    compliancePlatformNames:
        formData.compliancePlatformName,

    // Checkbox checked = user has NO challenges
    hasChallenges: formData.hasChallenges ? "no" : "yes",

    complianceChallenges: formData.hasChallenges
        ? []
        : [
              formData.priority1,
              formData.priority2,
              formData.priority3,
          ],

    otherChallenges: {
        otherChallenge1:
            formData.priority1 === "other1"
                ? formData.otherChallenge1
                : "",

        otherChallenge2:
            formData.priority2 === "other2"
                ? formData.otherChallenge2
                : "",

        otherChallenge3:
            formData.priority3 === "other3"
                ? formData.otherChallenge3
                : "",
    },

    followUpInterest: formData.interest,

    contactConsent: formData.consent,
};


        const confirmation = await swal({
            title: "Submit Assessment?",
            text: "Please review your information before submitting.",
            icon: "warning",
            buttons: {
                cancel: {
                    text: "Cancel",
                    visible: true,
                },
                confirm: {
                    text: "Yes, Submit",
                },
            },
        });

        if (!confirmation) {
            return;
        }

        try {
            const response = await fetch(`${baseURL}/form-submit`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result.success) {
   const content = document.createElement("div");

content.innerHTML = `
  <p>
    Thank you for completing the Network Compliance Management Assessment.
  </p>

  <p>
    Your Lucky Draw Coupon Code is:
  </p>

  <div style="
      color:#dc3545;
      font-size:28px;
      font-weight:bold;
      margin-top:10px;
      letter-spacing:2px;
  ">
      ${result.couponCode}
  </div>
`;

await swal({
    title: "🎉Assessment Submitted Successfully!",
    content,
    icon: "success",
    button: "Got It!",
});

                setFormData(INITIAL_FORM);
                setErrors(INITIAL_ERRORS);
            } else {
                await swal({
                    title: "Submission Failed",
                    text: result.message || "Something went wrong.",
                    icon: "error",
                    button: "OK",
                });
            }
        } catch (error) {
            console.error(error);

            await swal({
                title: "Server Error",
                text: "Something went wrong. Please try again later.",
                icon: "error",
                button: "OK",
            });
        }
    };

    useEffect(() => {
        fetchData();
    }, [])


    return (
        <div className="container py-5">
            <Seo
                title="Request a Demo"
                description="Request a demo or submit a query to Agilus Technologies for network compliance management assessment."
                path="/query-form"
            />
            <div className="card shadow mt-3">
                <div className="card-body p-5">
                    <h3 className="mb-1">Network Compliance Management Assessment</h3>
                    <p className="text-muted mb-4">
                        Thank you for visiting our booth. Please take a minute to share some
                        details so we can better understand your network compliance requirements.
                    </p>

                    <form onSubmit={handleSubmit} noValidate>
                        <SectionHeading>Contact Information</SectionHeading>
                        <div className="mb-3">
                            <label className="form-label fw-bold">Name
                                <span className="text-danger">*</span></label>
                            <ErrorMsg message={errors.name} />
                            <input
                            maxLength="100"
                                type="text"
                                   type="text"
    className={`form-control ${
        errors.name ? "is-invalid" : ""
    }`}
                                name="name"
                                value={formData.name}
                                onChange={handleTextField("name")}
                                 maxLength="100"
                                    onKeyDown={(e) => {
        if (e.target.selectionStart === 0 && e.key === " ") {
            e.preventDefault();
        }
    }}
                                placeholder="Your name"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-bold">
                                Official Business Email Address <span className="text-danger">*</span>
                            </label>
                            <ErrorMsg message={errors.email} />
                            <input
                                type="text"
                                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                name="email"
                                value={formData.email}
                                onChange={handleEmailChange}
                                placeholder="you@company.com"
                                                             maxLength="100"
                                    onKeyDown={(e) => {
        if (e.target.selectionStart === 0 && e.key === " ") {
            e.preventDefault();
        }
    }}
                            />

                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-bold">Organization Name</label>
                            <input
                                
                                   type="text"
    className={`form-control `}
                                name="organization"
                                value={formData.organization}
                                onChange={handleTextField("organization")}
                                placeholder="Your organization"
                                                             maxLength="100"
                                    onKeyDown={(e) => {
        if (e.target.selectionStart === 0 && e.key === " ") {
            e.preventDefault();
        }
    }}
                            />
                        </div>

                        <SectionHeading>Network Environment</SectionHeading>

                        <div className="mb-4">
                            <label className="form-label fw-bold">
                                Approximately how many network and security devices do you manage?{" "}
                                <span className="text-danger">*</span>
                                <ErrorMsg message={errors.deviceCount} />
                            </label>

                            <select
                             className={`form-select ${
        errors.deviceCount ? "is-invalid" : ""
    }`}
                                value={formData.deviceCount}
                                onChange={handleTextField("deviceCount")}
                            >
                                <option value="">Select Device Count</option>
                                {getField("deviceCount")?.options?.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="mb-4">
                            <label className="form-label fw-bold">
                                Which Network Monitoring System (NMS) are you currently using?{" "}
                                <span className="text-danger">*</span>
                                <ErrorMsg message={errors.nms} />
                            </label>

                            <Select
                                isMulti
    //          className={`form-select ${
    //     errors.nms ? "is-invalid" : ""
    // }`}
                                placeholder="Select NMS"
                                options={getField("nmsTools")?.options?.map((item) => ({
                                    value: item.value,
                                    label: item.label,
                                }))}
                                value={
                                    getField("nmsTools")?.options
                                        ?.filter((item) => formData.nms.includes(item.value))
                                        ?.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        })) || []
                                }
                                onChange={(selectedOptions) => {
                                    const values = selectedOptions
                                        ? selectedOptions.map((option) => option.value)
                                        : [];

                                    setFormData((prev) => ({
                                        ...prev,
                                        nms: values,
                                    }));
                                }}
                            />

                            {formData.nms.includes("other") && (
                                <div className="mt-2">
                                    <input
                                        type="text"
                                        className={`form-control ${errors.nms === "Please specify the Other NMS."
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        placeholder="Specify Other NMS"
                                        value={formData.otherNms}
                                        onChange={handleTextField("otherNms")}
                                                                     maxLength="100"
                                    onKeyDown={(e) => {
        if (e.target.selectionStart === 0 && e.key === " ") {
            e.preventDefault();
        }
    }}
                                    />

                                    {errors.nms === "Please specify the Other NMS." && (
                                        <ErrorMsg message={errors.nms} />
                                    )}
                                </div>
                            )}
                        </div>

                        {/* ── Compliance ── */}
                        <SectionHeading>Network Compliance &amp; Governance</SectionHeading>
                        <div className="mb-4">
                            <label className="form-label fw-bold">
                                Do you currently use a platform for Network Compliance Management?{" "}
                                <span className="text-danger">*</span>
                                <ErrorMsg message={errors.compliancePlatform} />
                            </label>

                            <select
                                className={`form-select ${errors.compliancePlatform ? "is-invalid" : ""
                                    }`}
                                name="compliancePlatform"
                                value={formData.compliancePlatform}
                                onChange={handleComplianceChange}
                            >
                                <option value="">Select an option</option>

                                {getField("usesCompliancePlatform")?.options?.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>

                            {formData.compliancePlatform?.toLowerCase() === "yes" && (
                                <div className="mt-3">
                                    <input
                                        type="text"
                                        className={`form-control ${errors.compliancePlatformName ? "is-invalid" : ""
                                            }`}
                                        placeholder="Platform name"
                                        name="compliancePlatformName"
                                        value={formData.compliancePlatformName}
                                        onChange={handleTextField("compliancePlatformName")}
                                                                     maxLength="100"
                                    onKeyDown={(e) => {
        if (e.target.selectionStart === 0 && e.key === " ") {
            e.preventDefault();
        }
    }}
                                    />

                                    <ErrorMsg message={errors.compliancePlatformName} />
                                </div>
                            )}
                        </div>

                        {/* ── Priorities ── */}
                        <div className="mb-4">
                            <label className="form-label fw-bold">
                                What is your top 3 network compliance management challenges today?
                                <span className="text-danger">*</span>
                                <ErrorMsg message={errors.hasChallenges} />
                            </label>

                         
                          

                                <>
                                    {/* Priority 1 */}
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Priority 1
                                            <span className="text-danger">*</span>
                                            <ErrorMsg message={errors.priority1} />
                                        </label>

                                        <select
                                                              className={`form-select ${
        errors.priority1 ? "is-invalid" : ""
    }`}
                                            
                                            value={formData.priority1}
                                            onChange={handlePriority1}
                                            disabled={formData.hasChallenges}
                                        >
                                            <option value="">
                                                Select Priority 1
                                            </option>

                                            {challengeOptions.map((item) => (
                                                <option
                                                    key={item.value}
                                                    value={item.value}
                                                >
                                                    {item.label}
                                                </option>
                                            ))}

                                            <option value="other1">
                                                Other
                                            </option>
                                        </select>

                                        {formData.priority1 === "other1" && (
                                            <>
                                                <ErrorMsg message={errors.otherChallenge1} />
                                                <input
                                                    type="text"
                                                     className={`form-control mt-2 ${
        errors.otherChallenge1 ? "is-invalid" : ""
    }`}
                                                    placeholder="Specify Other Challenge 1"
                                                    value={
                                                        formData.otherChallenge1
                                                    }
                                                                                 maxLength="100"
                                    onKeyDown={(e) => {
        if (e.target.selectionStart === 0 && e.key === " ") {
            e.preventDefault();
        }
    }}
                                                    onChange={(e) =>
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            otherChallenge1:
                                                                e.target.value,
                                                        }))
                                                    }
                                                />
                                            </>

                                        )}
                                    </div>

                                    {/* Priority 2 */}
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Priority 2
                                            <span className="text-danger">*</span>
                                            <ErrorMsg message={errors.priority2} />
                                        </label>

                                        <select
                                                              className={`form-select ${
        errors.priority2 ? "is-invalid" : ""
    }`}
                                            
                                            value={formData.priority2}
                                            onChange={handlePriority2}
                                            disabled={!formData.priority1}
                                        >
                                            <option value="">
                                                Select Priority 2
                                            </option>

                                            {challengeOptions.map((item) => (
                                                <option
                                                    key={item.value}
                                                    value={item.value}
                                                    disabled={
                                                        item.value ===
                                                        formData.priority1
                                                    }
                                                >
                                                    {item.label}
                                                </option>
                                            ))}

                                            <option value="other2">
                                                Other
                                            </option>
                                        </select>

                                        {formData.priority2 === "other2" && (
                                            <>
                                                <ErrorMsg message={errors.otherChallenge2} />
                                                <input
                                                    type="text"
                                                                                                className={`form-control mt-2 ${
        errors.otherChallenge2 ? "is-invalid" : ""
    }`}
                                                    placeholder="Specify Other Challenge 2"
                                                    value={
                                                        formData.otherChallenge2
                                                    }
                                                                                 maxLength="100"
                                    onKeyDown={(e) => {
        if (e.target.selectionStart === 0 && e.key === " ") {
            e.preventDefault();
        }
    }}
                                                    onChange={(e) =>
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            otherChallenge2:
                                                                e.target.value,
                                                        }))
                                                    }
                                                />
                                            </>
                                        )}
                                    </div>

                                    {/* Priority 3 */}
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Priority 3
                                            <span className="text-danger">*</span>
                                            <ErrorMsg message={errors.priority3} />
                                        </label>

                                        <select
                                                              className={`form-select ${
        errors.priority3 ? "is-invalid" : ""
    }`}
                                           
                                            value={formData.priority3}
                                            onChange={handlePriority3}
                                            disabled={!formData.priority2}
                                        >
                                            <option value="">
                                                Select Priority 3
                                            </option>

                                            {challengeOptions.map((item) => (
                                                <option
                                                    key={item.value}
                                                    value={item.value}
                                                    disabled={
                                                        item.value ===
                                                        formData.priority1 ||
                                                        item.value ===
                                                        formData.priority2
                                                    }
                                                >
                                                    {item.label}
                                                </option>
                                            ))}

                                            <option value="other3">
                                                Other
                                            </option>
                                        </select>

                                        {formData.priority3 === "other3" && (
                                            <>
                                                <ErrorMsg message={errors.otherChallenge3} />
                                                <input
                                                    type="text"
                                                   className={`form-control mt-2 ${
        errors.otherChallenge3 ? "is-invalid" : ""
    }`}
                                                    placeholder="Specify Other Challenge 3"
                                                    value={
                                                        formData.otherChallenge3
                                                    }
                                                                                 maxLength="100"
                                    onKeyDown={(e) => {
        if (e.target.selectionStart === 0 && e.key === " ") {
            e.preventDefault();
        }
    }}
                                                    onChange={(e) =>
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            otherChallenge3:
                                                                e.target.value,
                                                        }))
                                                    }
                                                />
                                            </>
                                        )}
                                    </div>
                                 <div className="form-check mb-3">
    <input
        type="checkbox"
        className="form-check-input"
        id="challengeNo"
        checked={formData.hasChallenges}
        onChange={(e) =>
            setFormData((prev) => ({
                ...prev,
                hasChallenges: e.target.checked,

                priority1: e.target.checked ? "" : prev.priority1,
                priority2: e.target.checked ? "" : prev.priority2,
                priority3: e.target.checked ? "" : prev.priority3,

                otherChallenge1: e.target.checked ? "" : prev.otherChallenge1,
                otherChallenge2: e.target.checked ? "" : prev.otherChallenge2,
                otherChallenge3: e.target.checked ? "" : prev.otherChallenge3,
            }))
        }
    />

    <label
        htmlFor="challengeNo"
        className="form-check-label"
    >
        I don't have any challenges
    </label>
</div>
                                </>
                        </div>

                        {/* ── Follow-up ── */}
                        <SectionHeading>Follow-up</SectionHeading>

                        <div className="mb-3">
                            <label className="form-label fw-bold">
                                Are you interested in learning more about network monitoring,
                                compliance automation, and configuration management solutions?{" "}
                                <span className="text-danger">*</span>
                                <ErrorMsg message={errors.interest} />
                            </label>

                            <select
                                className={`form-select ${errors.interest ? "is-invalid" : ""}`}
                                value={formData.interest}
                                onChange={handleRadio("interest")}
                            >
                                <option value="">Select an option</option>

                                {getField("followUpInterest")?.options?.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* ── Consent ── */}
                        <div className="form-check mt-4">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                                                             className={`form-check-input ${
        errors.consent ? "is-invalid" : ""
    }`}
                                name="consent"
                                id="consent"
                                checked={formData.consent}
                                onChange={handleConsent}
                            />
                            <label className="form-check-label" htmlFor="consent">
                                I agree to be contacted regarding products, services, and event
                                follow-up discussions.
                            </label>
                            <ErrorMsg message={errors.consent} />
                        </div>

                        <button type="submit" className="btn btn-primary mt-4">
                            Submit Assessment
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
